/**
 * student/campaigns — KEYS.
 * Hierarchical query-key factory. `all()` is the domain root, so
 * `qc.invalidateQueries({ queryKey: studentCampaignsKeys.all() })` wipes every
 * campaign query (lists, details, articles, gameplay context) at once.
 */
export const studentCampaignsKeys = {
  all: () => ['student', 'campaigns'] as const,
  lists: () => [...studentCampaignsKeys.all(), 'list'] as const,
  detail: (id: string) => [...studentCampaignsKeys.all(), 'detail', id] as const,
  article: (campaignId: string, activityId: string) =>
    [...studentCampaignsKeys.all(), 'article', campaignId, activityId] as const,
  materialArticle: (campaignId: string, materialId: string) =>
    [...studentCampaignsKeys.all(), 'material-article', campaignId, materialId] as const,
  gameplayContext: (campaignId: string, activityId: string) =>
    [...studentCampaignsKeys.all(), 'gameplay-context', campaignId, activityId] as const,
};
